import apiClient from './client';

export interface TranscribeResponse {
  /** Transcript in the language it was spoken in (Devanagari when that is Hindi). */
  text: string;
  /** The server recognizes these two only, treating any other detection as Hindi. */
  language?: 'english' | 'hindi';
  /** English translation of `text`, present only when `language` is `hindi`. */
  translatedText?: string;
}

export const transcribeApi = {
  // Sends a recorded voice clip to the backend and gets back the
  // transcribed text (the language is detected server-side).
  transcribeAudio: async (audioBlob: Blob, filename: string): Promise<TranscribeResponse> => {
    const formData = new FormData();
    formData.append('audio', audioBlob, filename);

    const response = await apiClient.post('/business/transcribe', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data.data;
  },
};
